import EducationCard from "./EducationCard";

export default EducationCard;